// src/components/MyReports.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate , useLocation} from 'react-router-dom';
import { format } from 'date-fns';
import { Loader2, AlertCircle, ChevronRight } from 'lucide-react';
import './MyReports.css'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { faFileContract } from '@fortawesome/free-solid-svg-icons';

const REACT_APP_API_BASE = process.env.REACT_APP_API_BASE;

const formatDateSafely = (dateValue, formatString) => {
    if (!dateValue) {
        return 'N/A';
    }
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }
    return format(date, formatString);
};

const MyReports = () => {
    const [reports, setReports] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const userId = localStorage.getItem('userId');

    
   const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

    useEffect(() => {
        if (!userId) {
            setIsLoading(false);
            return;
        }
        const fetchReports = async () => {
            setIsLoading(true);
            try {
                const { data } = await axios.get(`${REACT_APP_API_BASE}/api/reports/all/${userId}`);
                setReports(data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
            } catch (error) {
                console.error("Failed to fetch reports:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchReports();
    }, [userId]);

   const handleViewReport = (report) => {
  const packageName = (report.packageName || '').toLowerCase();

  if (packageName.includes('advance')) {
    // ₹249 → final plus report
    navigate(`/dashboard?view=report-plus&id=${report._id}`);
  } else if (packageName.includes('smart')) {
    // ₹149 → final smart report
    navigate(`/dashboard?view=report-premium&id=${report._id}`);
  } else {
    // everything else → basic report
    navigate(`/dashboard?view=report-result&id=${report._id}`);
  }
};


    if (isLoading) {
        return (
            <div className="reports-page-container loading-state">
                <Loader2 className="animate-spin" size={40} />
                <p>Loading Your Reports...</p>
            </div>
        );
    }

    

    return (
        <>
            <Helmet>
                <meta name="title" content="My Reports | Get Next Visa" />
                <title>My Reports | Get Next Visa - AI Powered Student Visa Report</title>
                <meta name="description" content="Access all your previously generated AI-powered visa and education reports." />
            </Helmet>

            <div className="reports-page-container">
                <div className="form-header-report">
                    <h1 className="form-header-title"><FontAwesomeIcon className="report-icon" icon={faFileContract} size="2x" /> My Generated Reports</h1>
                </div>

                {reports.length === 0 ? (
                    <div className="reports-empty-state">
                        <AlertCircle size={48} />
                        <h2>No Reports Found</h2>
                        <p>You haven't generated any AI analysis reports yet.</p>
                        <button onClick={() => navigate('/dashboard?view=get-ai-report')}>Generate Your First Report</button>
                    </div>
                ) : (
                    <div className="reports-grid">
                        {reports.map((report) => (
                            <div key={report._id} className="report-card">
                                <div className="report-card-header">
                                    <img src="/photos/heading.png" alt="Get Next Visa Logo" className="report-card-logo" />
                                    <div className="report-header-text">
                                        <h3 className="report-package-name">{report.packageName}</h3>
                                        <p className="report-date-time">
                                            {formatDateSafely(report.createdAt, 'dd MMM yyyy, p')}
                                        </p>
                                    </div>
                                </div>
                                <div className="report-card-body">
                                    <p className="report-student-name">
                                        For: {report.formDataSnapshot?.firstName || report.aiResults?.studentInfo?.name || 'N/A'}
                                    </p>
                                </div>
                                <div className="report-card-footer">
                                    <button onClick={() => handleViewReport(report)} className="view-report-btn">
                                        View Full Report
                                        <ChevronRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default MyReports;